import React from 'react'
import { PageBlock } from './types'
import { GatsbyImage } from 'gatsby-plugin-image';

// @ts-expect-error
import { benefitsContainer, hpSectionHeading } from './index.module.scss';

const ImageBlock = ({ data }: { data: PageBlock }) => {
  const { title, subtitle, image } = data;

  return image ? (
    <>
      <div className={benefitsContainer}>
        <h3 style={subtitle ? {} : { marginBottom: 20 }} className={`${hpSectionHeading}`}>{title}</h3>
        {subtitle && (
          <p>{subtitle}</p>
        )}
      </div>
      <div style={{ justifyContent: 'center', display: 'flex' }} className="mx-5">
        <GatsbyImage
          style={{ maxWidth: 700 }}
          image={image.asset.gatsbyImageData}
          className={`img-fluid`}
          alt={title || ''} />
      </div>
    </>
  ) : null;
}

export default ImageBlock
